import React, {useEffect, useState} from "react";
import {Button, Col, FormControl, FormGroup, InputGroup, Row} from "react-bootstrap";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from './AchApi'
import {useMediaQuery} from '../../../../utilities/hooks/useMediaQuery';

const Ach = ({total, setACHCharge, invoiceToken, actions}) => {
    const isMobile = useMediaQuery(991);
    const [isPaymentLoading, setIsPaymentLoading] = useState(false)
    const [payPartial, setPayPartial] = useState(false)
    const [partialAmount, setPartialAmount] = useState('')
    const [acceptedPartialValue, setAcceptedPartialValue] = useState('')

    useEffect(() => {
        setACHCharge(payPartial ? acceptedPartialValue : total)
    }, [acceptedPartialValue, payPartial]);

    const calculateACHValue = (amount) => {
        if (amount) {
            let basedAmount = parseFloat(amount)
            let totalACHAmount = basedAmount / (1 - 0.008)

            if (basedAmount > 625) {
                return (basedAmount + 5).toFixed(2)
            } else {
                return (basedAmount + (totalACHAmount - basedAmount)).toFixed(2)
            }
        }
    }

    const validPartialAmount = partialAmount.length === 0 || partialAmount < 0 || partialAmount > total ? total : partialAmount;

    const handleAchPay = () => {
        setIsPaymentLoading(true)
        const amount = payPartial ? acceptedPartialValue : total
        actions.achCheckout(invoiceToken, amount, (res) => {
            localStorage.setItem('ach_payment', "true")
            window.location.href = res.checkout_url
        })
    }

    return (
        <Row className={`d-flex no-left-margin mt-15 ${isMobile && 'columnDirection'}`}>
            <Col xs={isMobile ? 7 : 4}>
                <Row>
                    <Button disabled={isPaymentLoading} className="no-border-radius"
                            onClick={() => handleAchPay()}>{isPaymentLoading ? "...Loading" : payPartial && acceptedPartialValue ? `Pay $${calculateACHValue(acceptedPartialValue)}` : `Pay $${calculateACHValue(total)}`}</Button>
                    <Button onClick={() => setPayPartial(!payPartial)}
                            className="no-border-radius">Pay
                        partial</Button>
                </Row>
            </Col>
            {payPartial ?
                <Col xs={5} className={isMobile && 'mt-15 width-80 no-left-padding'}>
                    <FormGroup className='d-flex bottom0'>
                        <InputGroup>
                            <InputGroup.Addon>$</InputGroup.Addon>
                            <FormControl type="number" value={partialAmount}
                                         onChange={e => {
                                             const value = e.target.value
                                             const match_value = value ? value.toString().match(/^(\d+\.\d{0,2})/) : value

                                             if (value > total) {
                                                 setPartialAmount(total)
                                             } else {
                                                 setPartialAmount(match_value ? match_value[1] : value)
                                             }
                                         }}
                                         className="border_none"
                            />
                        </InputGroup>
                        <button className="border_none" onClick={() => {
                            setAcceptedPartialValue(validPartialAmount)
                        }}>Accept
                            Amount
                        </button>
                    </FormGroup>
                </Col>
                : null}
        </Row>
    )
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default connect(null, mapDispatchToProps)(Ach)
